// extracted by mini-css-extract-plugin
module.exports = {"list-wrapper":"list-wrapper_list-wrapper__O2oWS"};